import api from "api";
import { useCallback, useEffect, useState } from "react";
import { setLoading, setDialog } from "slices/appSlice";
import { useDispatch } from "react-redux";
export default function useFeatureFlag() {
  const dispatch = useDispatch();

  const [featureFlags, setFeatureFlags] = useState(null);

  const fetchFlags = useCallback(async () => {
    dispatch(setLoading(true));

    try {
      const res = await api.featureFlag.getFeatureFlags();

      if (res.status === 200) {
        setFeatureFlags(res.data);
      }
    } catch (e) {
      console.log(e.message);
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch]);

  return [featureFlags, fetchFlags];
}
